// Recognises Plivo staff and our internal test tenants from their email, so
// analytics can leave them out.
//
// Storage is read here directly instead of through `getLocalAuth()` in `v2/utils`:
// this module is imported by `monitorToolsSetup`, which is the very first import in
// index.jsx, and that barrel pulls in React Router plus the logger (which itself
// pulls LogRocket). Bootstrap-time work should not drag the app graph in behind it.
const AUTH_STORAGE_KEY = 'auth'

// Anchored with endsWith: a substring match would swallow real customers at
// plivocustomer.com or sanitysolutions.com. The sanity orgs are our smoke tests.
const INTERNAL_EMAIL_SUFFIXES = ['@plivo.com', '@southsanity.com', '@useastsanity.com']

export const isInternalEmail = (email?: string | null): boolean => {
  if (!email) return false
  const normalised = email.trim().toLowerCase()
  return INTERNAL_EMAIL_SUFFIXES.some((suffix) => normalised.endsWith(suffix))
}

// The signed-in user's email as persisted at login, or '' when nobody is signed in.
// Also '' when storage throws — Safari Lockdown Mode and some WebViews deny access
// (SER-6066) — which fails open: an unknown user is treated as external and recorded.
export const getStoredAuthEmail = (): string => {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY)
    if (!raw) return ''
    const auth = JSON.parse(raw) as { email?: unknown }
    return typeof auth?.email === 'string' ? auth.email : ''
  } catch {
    return ''
  }
}

// True when the browser already holds an internal session. Callable at module
// load — login persists `auth`, so this resolves before posthog.init/initLogRocket.
export const isInternalSession = (): boolean => isInternalEmail(getStoredAuthEmail())
